import React, { Component } from 'react';
import { Link } from 'redux-little-router';

import { routeMap } from 'router';

export default class EsiaError extends Component {
  render() {
    return (
      <div className="page_margin30">
        <p>Уважаемый пользователь!</p>
        <p>
          Сервис авторизации через Госуслуги (ЕСИА) временно недоступен. Выберите другой способ
          входа в личный&nbsp; кабинет или попробуйте ещё раз позднее.
        </p>
        <Link href={routeMap.login}>Вернуться к форме авторизации</Link>
      </div>
    );
  }
}
